import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { colours } from '@qflow/theme'

import { icons, ColourButton, Spacer, Label } from 'portal/lib/primitives'

export function RemoveButton({
  children = 'Remove',
  iconOnly = false,
  ...props
}) {
  if (iconOnly) {
    return (
      <Tooltip title={children}>
        <ColourButton.BasicBorderless
          id="RemoveButton"
          style={{ padding: '4px 9px', borderRadius: '50%' }}
          {...props}
        >
          <icons.TrashCan colour={colours.ERROR} />
        </ColourButton.BasicBorderless>
      </Tooltip>
    )
  }

  return (
    <ColourButton.Negative id="RemoveButton" {...props}>
      <icons.TrashCan colour="currentColor" />

      <Spacer.Fine />

      <Label isChild colour="inherit">
        {children}
      </Label>
    </ColourButton.Negative>
  )
}

RemoveButton.propTypes = {
  ...ColourButton.Negative.propTypes,
  children: PropTypes.string
}
